export default "__VITE_ASSET__e2e3d577__"